<template>
  <footer id="footer" class="text-center col-xs-12" style="display: none">
    <div class="social-icons-container">
      <a
        class="social-icon gtm_socialiconCX2"
        href="https://www.facebook.com/MarcusThomasCLE/"
        target="_blank"
        title="Go to Marcus Thomas's Facebook"
        ><icon name="facebook"></icon
      ></a>
      <a
        class="social-icon gtm_socialiconCX2"
        href="https://twitter.com/MarcusThomasCle"
        target="_blank"
        title="Go to Marcus Thomas's Twitter"
        ><icon name="twitter"></icon
      ></a>
      <a
        class="social-icon gtm_socialiconCX2"
        href="https://www.linkedin.com/company/marcus-thomas-llc?trk=top_nav_home"
        target="_blank"
        title="Go to Marcus Thomas's Linked In"
        ><icon name="linkedin"></icon
      ></a>
      <a
        class="social-icon gtm_socialiconCX2"
        href="https://www.instagram.com/marcusthomasllc/"
        target="_blank"
        title="Go to Marcus Thomas's Instagram"
        ><icon name="instagram"></icon
      ></a>
    </div>
    <div class="social-copy">
      <p class="strech">
        Marcus Thomas LLC, with nearly 300 professionals in its offices in
        Cleveland and Cincinnati, Ohio, Buenos Aires, Argentina and Santiago,
        Chile, is among America’s leading independent, full-service, integrated
        advertising agencies. Marcus Thomas is a recognized leader in creative,
        media, public relations, social media, digital strategy and technology.
      </p>
      <p>
        &copy; Marcus Thomas LLC | Cleveland + Cincinnati + Buenos Aires +
        Santiago<br />4781 Richmond Road Cleveland, Ohio 44128 (216) 292.4700
        (888) 482.4455
      </p>
      <p>
        <router-link v-bind:to="'/terms'">Terms & Conditions</router-link> |
        <router-link v-bind:to="'/privacy'">Privacy Policy</router-link>
      </p>
    </div>
    <cookie-bar></cookie-bar>
  </footer>
</template>

<script>
import cookieBar from "../components/cookie-bar.vue";
export default {
  name: "Footer",
  props: {
    version: {
      type: String,
      default: "",
    },
  },
  components: {
    "cookie-bar": cookieBar,
  },
};
</script>



// WEBPACK FOOTER //
// footer-component.vue?02f319a0